// this is an autogenerated file from App/Account/Content/Calendar/New/Content/mutation-upsert-user-settings.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Calendar_New_Content(
  $object: calendar_user_settings_insert_input!
  $columns_to_update: [calendar_user_settings_update_column!]!
) {
  insert_calendar_user_settings_one(
    object: $object
    on_conflict: {
      constraint: settings_user_id_location_id_key
      update_columns: $columns_to_update
    }
  ) {
    id
    user_id
    location_id
    slot_interval
    selected_appointment_templates
  }
}

`